import { parseNorma43 } from "./norma43";
import { isSantanderTxt, parseSantanderTxt } from "./santanderTxt";

export function decodeBankStatement(buffer: ArrayBuffer): string {
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(buffer);
  } catch {
    return new TextDecoder("windows-1252").decode(buffer);
  }
}

export function parseBankStatement(text: string) {
  const clean = text.replace(/^\uFEFF/, "");
  if (isSantanderTxt(clean)) return parseSantanderTxt(clean);
  // No interpretar las fechas o el texto de un TXT arbitrario como registros N43.
  if (!/^11\d{18}\d{12}[12]\d{14}/m.test(clean.replace(/\r/g, ""))) return [];
  return parseNorma43(clean);
}